import React from 'react';
import ProductDashboardPage from '@/components/dashboard/ProductDashboardPage';

const UserFlexgeld = () => {
  return (
    <ProductDashboardPage
      title="Flexgeld"
      productType="Flexgeld"
      subtitle="Hybride Anlage mit Tageszugriff und attraktiver Verzinsung."
      ctaLabel="Flexgeld eröffnen"
    />
  );
};

export default UserFlexgeld;
